'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const DEFAULT_REM = 16;
var useRem = () => {
  if (typeof document !== 'object' || !document.documentElement) {
    return DEFAULT_REM;
  }
  const {
    current: css
  } = React.useRef(window.getComputedStyle(document.documentElement));
  const fontSizeParsed = parseInt((css.fontSize || '').replace('px', ''), 10);
  return Number.isNaN(fontSizeParsed) ? DEFAULT_REM : fontSizeParsed;
};

exports.DEFAULT_REM = DEFAULT_REM;
exports["default"] = useRem;
